import Slide from '@mui/material/Slide';
import React from 'react';

export type TransitionProps = {
  children?: React.ReactElement;
};

const DialogTransition = React.forwardRef(function Transition(
  props: TransitionProps,
  ref
) {
  return (
    <Slide direction="down" ref={ref} {...props}>
      {props.children || <></>}
    </Slide>
  );
});

export default DialogTransition;
